import { type Masked, unmask } from '~/contentful/graphql';
import { isNonOptional } from '~/contentful/utils/optional';
import { type HeroAssetType } from '~/ui/modules/heroAsset';
import { getAspectRatio } from '~/ui/utils/aspectRatio';

import { type Image_AssetFragment } from './query';

export function getImageAspectRatio(image: Masked<HeroAssetType>) {
  const unmaskedImage = unmask<HeroAssetType>(image);
  const resolvedImage =
    'image' in unmaskedImage
      ? (unmaskedImage.image as Masked<typeof Image_AssetFragment>)
      : (unmaskedImage as Masked<typeof Image_AssetFragment>);
  if (resolvedImage) {
    const { width, height } = unmask<typeof Image_AssetFragment>(resolvedImage);
    if (isNonOptional(width) && isNonOptional(height)) {
      return getAspectRatio({ width, height });
    }
  }
}
